export default __webpack_public_path__ + "static/downbracket-96a16acea04bd5f9e7ba2e40279d2870.png";